// ============================================================================
// HAMILTONIAN CYCLE - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'hamiltonian-cycle',
  name: 'Hamiltonian Cycle',
  category: 'Backtracking',
  complexity: {
    time: 'O(n!)',
    space: 'O(n^2)'
  },
  description: 'Hamiltonian Cycle finds a cycle in an undirected graph that visits every vertex exactly once using backtracking.'
};
export type MetaType = typeof meta;
